import { create } from "zustand";

// Coordinates between the app-level "What's New" tour and the per-module
// walkthroughs. The What's New tour navigates ACROSS modules, mounting pages
// that would otherwise auto-start their own walkthrough (see
// useModuleWalkthrough's auto-start effect) — leaving two tours running at once.
//
// While `isExternalTourActive` is true, module walkthroughs skip their
// auto-start. The What's New controller flips it on for the lifetime of its tour
// queue and off when the queue ends.
interface IWalkthroughCoordinationStore {
  isExternalTourActive: boolean;
  setExternalTourActive: (active: boolean) => void;
}

export const useWalkthroughCoordination = create<IWalkthroughCoordinationStore>(
  (set) => ({
    isExternalTourActive: false,
    setExternalTourActive: (active) => set({ isExternalTourActive: active }),
  }),
);

export default useWalkthroughCoordination;
